/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Fieldengineerid2Inputs */

const en__field_fieldengineerid2 = /** @type {(inputs: _Field_Fieldengineerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field engineer`)
};

/**
* | output |
* | --- |
* | "Field engineer" |
*
* @param {_Field_Fieldengineerid2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_fieldengineerid2 = /** @type {((inputs?: _Field_Fieldengineerid2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Fieldengineerid2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_fieldengineerid2(inputs)
});
export { _field_fieldengineerid2 as "_field_fieldEngineerId" }